import React from 'react';
import { TableSorting } from 'types/state';

type Params<SortableFieldType> = {
  initialField: SortableFieldType;
  initialAscending: boolean;
};

type TableSortingController<SortableFieldType> = {
  tableSorting: TableSorting<SortableFieldType>;
  sortBy(field: SortableFieldType): void;
};

export const useTableSortingController = <SortableFieldType>(
  params: Params<SortableFieldType>
): TableSortingController<SortableFieldType> => {
  const [field, setField] = React.useState<SortableFieldType>(
    params.initialField
  );

  const [ascending, setAscendig] = React.useState<boolean>(
    params.initialAscending
  );

  const sortBy = React.useCallback(
    (nextField: SortableFieldType) => {
      if (field === nextField) {
        setAscendig((prevValue) => !prevValue);
      } else {
        setField(nextField);
        setAscendig(params.initialAscending);
      }
    },
    [field, params.initialAscending]
  );

  const tableSorting = React.useMemo<TableSorting<SortableFieldType>>(
    () => ({
      ascending,
      field,
    }),
    [ascending, field]
  );

  return { tableSorting, sortBy };
};
